/**
 * Draft meeting state constants — mirrors Blazor's `Statuses` static class exactly.
 * Use these instead of raw strings throughout the codebase so that any future
 * backend rename only needs to be changed here.
 */
export const Statuses = {
  NewRequest:           "New Request",
  ProgramOwnerReviewed: "Program Owner Reviewed",
  DUReview:           "DU Review",
  /** "Push to Summit" in the API — Blazor: Statuses.Resolved */
  Resolved:            "Push to Summit",
  CreatedInSummit:     "Created in Summit",
  DUDeclined:          "DU Declined",
  Removed:             "Removed",
  Softhold:            "Soft Hold",
  ConfirmedEvent:      "Confirmed Event",
  DidNotMaterialize:   "Did Not Materialize",
  Draft:               "Draft",
  Core:                "Core",
  Secondary:           "Secondary",
  CNFCREATEDSCS:       "CNF_CREATEDSCS",
} as const;

export type StatusValue = (typeof Statuses)[keyof typeof Statuses];
